import { createApp } from '@app/adapters/create-app'

import CompanyUsers from '@app/company-users/components/company-users'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='company_users']").each(function () {
    createApp(CompanyUsers, {
      isRelaxedLayout: this.dataset.relaxedLayout,
    }).mount(this)
  })
})
